<!-- calendar-view.component.html -->
<div class="calendar-container">
  <!-- Internal Header (shown when useExternalDateSelection is false) -->
  @if (!useExternalDateSelection) {
    <div class="calendar-header">
      <button (click)="navigateMonth(-1)" class="nav-button button-icon-only">
        <app-icon color="var(--black)" iconName="chevron-left"></app-icon>
      </button>

      <h1 class="month-title">{{ currentMonthYear }}</h1>

      <button (click)="navigateMonth(1)" class="nav-button button-icon-only">
        <app-icon color="var(--black)" iconName="chevron-right"></app-icon>
      </button>
    </div>
  }

  @if (!isLoading) {
    <!-- Calendar -->
    <div class="calendar-wrapper">
      <!-- Days of week header -->
      <div class="calendar-header-row">
        @for (day of dayNames; track day) {
          <div class="day-header">
            {{ day }}
          </div>
        }
      </div>
      <!-- Calendar grid -->
      <div class="calendar-grid">
        @for (dayData of calendarDays; track $index) {
          <div class="calendar-cell" [class.other-month]="!dayData.isCurrentMonth" [class.today]="dayData.isToday" [class.weekend]="dayData.isWeekend" (click)="onDayCellClick(dayData)">
            <div class="events-container">
              <!-- Show first 3 events -->
              @for (event of getVisibleEvents(dayData.events); track event.id) {
                <div [class]="'event-item ' + getEventClass(event.type)" [tippy]="event.title" (click)="eventClicked.emit(event); $event.stopPropagation()">
                  <div class="event-time">{{ event.time ? (event.time | date: 'HH:mm') : (event.startTime | date: 'HH:mm') }}</div>
                  <div class="event-title">{{ event.title | truncateText: 50 }}</div>
                </div>
              }

              <!-- Show more button if there are more than 3 events -->
              @if (hasMoreEvents(dayData.events)) {
                <div class="show-more-button" (click)="showAllEvents(dayData); $event.stopPropagation()">
                  <span class="more-text">+{{ getRemainingEventsCount(dayData.events) }} {{ 'nav.more' | translate }}</span>
                  <app-icon color="var(--text-color-medium)" iconName="chevron-down" size="12px"></app-icon>
                </div>
              }
            </div>

            <div class="day-number">
              {{ dayData.day.toString().padStart(2, '0') }}
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <!-- Loading State -->
    <div class="calendar-wrapper">
      <!-- Days of week header still shown during loading -->
      <div class="calendar-header-row">
        @for (day of dayNames; track day) {
          <div class="day-header">
            {{ day }}
          </div>
        }
      </div>

      <!-- Skeleton Grid -->
      <div class="calendar-grid">
        @for (_ of [].constructor(42); track $index) {
          <div class="calendar-cell">
            <!-- Full-cell skeleton -->
            <ngx-skeleton-loader [theme]="{ width: '100%', height: '100%', 'border-radius': '4px', border: '1px solid var(--gray-200)' }"></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
  }
</div>
